import React, { ReactNode } from "react";
import { Routes, Route, Params, Navigate } from "react-router-dom";
import { Provider } from "mobx-react";
import { Loader, UtilityMethods, withRouter } from "@mindmemobile/mm-shared-global";
import FindAccount from "./FindAccount";
import { AuthService } from "../shared/services";

interface IProps {
  location: Location;
  params: Readonly<Params<string>>;
}

class FindAccountRoutes extends React.Component<IProps> {
  get id() {
    const split = ((this.props.params && this.props.params["*"]) || "").split(
      "/"
    );
    const id = split[split.length - 1];
    if (UtilityMethods.isValidObjectId(id)) {
      return id;
    }
    return null;
  }

  get routes() { 
    if(!AuthService.mindmeAccountDetails &&this.props.location.search.includes("mm=true")) {  
      return new Loader(true).loaderComponent;
    }
    return (
      <Routes>
        <Route path={`/`} element={<FindAccount />} />
        <Route
          path={`/contact/:id?`}
          element={<FindAccount contactId={this.id} />}
        />
        <Route path="*" element={<Navigate to="/app/find-account" />} />
      </Routes>
    );
  }

  render(): ReactNode {
    return <Provider>{this.routes}</Provider>;
  }
}

export default withRouter(FindAccountRoutes);
